import React, { useState } from "react";
import LogoImg from "../../../assets/images/logo-placeholder.png"
import FaviconImg from "../../../assets/images/favicon-placeholder.png"
import Accordion from "../accordion/Accordion";
import { UserIcon } from '@heroicons/react/outline';
import { Link } from "react-router-dom";
import ROUTES, { RenderRoutes, getRoutes } from "../../../router/routes";
import useHandleClickOutside from '../HandleClickOutside/HandleClickOutside';
import { ChevronRightIcon } from '@heroicons/react/outline'

const Sidebar = () => {
    const [isDesktopActive, setIsDesktopActive] = useState(false)
    const [isMobileActive, setIsMobileActive] = useState(false)
    const handleToggleMobileActive = () => setIsMobileActive(isActive => !isActive);

    let domNode = useHandleClickOutside(() => {
        setIsMobileActive(false);
        setIsDesktopActive(false);
    })


    /**
 * Render a nested hierarchy of route configs with unknown depth/breadth
 */
    function displayRouteMenu(routes) {
        /**
         * Render a single route as a list item link to the config's pathname
         */
        function singleRoute(route, key) {
            return route.hideInSidebar ? '' : (
                <li className="whitespace-nowrap" key={key}>
                    <Link to={route.path} key={route.key} className="links-sidenav" onClick={() => {
                        setIsDesktopActive(false);
                        setIsMobileActive(false);
                    }}>
                        {route.icon}
                        <span className={`transition ${isMobileActive ? 'opacity-100' : 'opacity-0'} ${isDesktopActive ? 'lg:opacity-100' : 'lg:opacity-0'}`}>
                            {route.key}
                        </span>
                    </Link>
                </li>
            );
        }

        // loop through the array of routes and generate an unordered list
        return (
            <ul>
                {routes.map((route, key) => {
                    // if this route has sub-routes, then show the ROOT as a list item and recursively render a nested list of route links
                    if (route.routes) {
                        return (
                            <li key={key}>
                                <React.Fragment key={route.key}>
                                    <Accordion PagesGroupName={route.key} PageLinks={route.routes} icon={<UserIcon className="w-4 h-4 my-2 mr-3.5" />} />
                                    {/* {displayRouteMenu(route.routes)} */}
                                </React.Fragment>
                            </li>
                        );
                    }
                    return singleRoute(route, key);
                })}
            </ul>
        );
    }

    return (
        <aside ref={domNode} onMouseEnter={() => setIsDesktopActive(true)} onMouseLeave={() => setIsDesktopActive(false)} className={`fixed left-0 top-0  w-full h-full blueGradientReverse shadow-sidebar z-20 transition-all  duration-[400ms] ${isDesktopActive ? 'lg:w-sidebarOpenWidth' : 'lg:w-sidebarClosedWidth'} ${isMobileActive ? 'w-sidebarOpenWidth' : 'w-sidebarClosedWidth'}`}>
            <button className="lg:hidden absolute top-[19px] right-0 transform translate-x-full w-6 p-0.5 h-8 flex items-center justify-center rounded-tr-full rounded-br-full bg-primary shadow-hamburger" onClick={handleToggleMobileActive}>
                <ChevronRightIcon className={`w-4 mr-1 text-white transform transition duration-[400ms] ${isMobileActive ? 'rotate-180' : 'rotate-0'}`} />
                {/* <div className={`hamburger  ${isMobileActive ? '-active' : ''}`}
                    
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </div> */}
            </button>
            <div className=" overflow-hidden">
                <div className="relative h-topbarHeight">
                    <div className="relative flex h-full w-sidebarOpenWidth">
                        <img src={LogoImg} alt="Logo" className={`absolute top-1/2 left-0 transform -translate-y-1/2 w-auto transition ${isMobileActive ? 'opacity-100' : 'opacity-0'} ${isDesktopActive ? 'lg:opacity-100' : 'lg:opacity-0'}`} />
                        <img src={FaviconImg} alt="Logo xs" className={`absolute top-1/2 left-0 transform -translate-y-1/2  w-sidebarClosedWidth transition ${isMobileActive ? 'opacity-0' : 'opacity-100'} ${isDesktopActive ? 'lg:opacity-0' : 'lg:opacity-100'}`} />
                    </div>
                </div>
                <div className="h-full w-full flex flex-col py-2  lg:bg-none transition-transform">
                    {/* <div className={`absolute left-0 top-topbarHeight w-sidebarWidth h-sidebarNavHeight lg:w-full flex flex-col py-2  blueGradientReverse lg:bg-none transition-transform ${isDesktopActive ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}> */}
                    {displayRouteMenu(getRoutes())}
                </div>
            </div>
        </aside >
    )
};

export default Sidebar;

